import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=e4236128"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"
import style0 from "./ProductModal.vue?vue&type=style&index=0&id=e4236128&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports